import { apiPortalRh } from './api';

export const integration = async (payload) =>
  await apiPortalRh.post(`/integrations/generic`, payload, {});
